import { useState, useEffect } from 'react';
import api from '../services/api';

const MAX_ITEMS = 6;
const STORAGE_KEY = 'recentlyViewed';

export function useRecentlyViewed() {
  const [recentlyViewed, setRecentlyViewed] =
    useState([]);

  useEffect(() => {
    const stored =
      localStorage.getItem(STORAGE_KEY);
    if (!stored) return;
    let parsed;
    try {
      parsed = JSON.parse(stored);
    } catch {
      setRecentlyViewed([]);
      return;
    }
    if (!Array.isArray(parsed) || parsed.length === 0) {
      setRecentlyViewed(parsed || []);
      return;
    }
    setRecentlyViewed(parsed);

    const ids = parsed.map(p => p.id).join(',');
    api.get(`/api/products/batch?ids=${ids}`)
      .then(data => {
        const liveMap = new Map(
          (data.products || []).map(p => [p.id, p])
        );
        const validated = parsed.filter(item => {
          const live = liveMap.get(item.id);
          if (!live) return false;
          item.stock_quantity = live.stock_quantity;
          item.total_stock = live.total_stock;
          item.has_variants = live.has_variants;
          item.total_variants = live.total_variants || 0;
          item.min_price = live.min_price;
          item.max_price = live.max_price;
          item.price = live.price;
          item.finalPrice = live.finalPrice || live.price || 0;
          return true;
        });
        setRecentlyViewed(validated);
        localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify(validated)
        );
      })
      .catch(() => {});
  }, []);

  const addToRecentlyViewed = (product) => {
    if (!product?.id) return;
    setRecentlyViewed(prev => {
      const filtered = prev.filter(
        p => p.id !== product.id
      );
      const updated = [
        {
          id: product.id,
          name: product.name,
          brand: product.brand,
          price: product.price,
          image: product.image,
          has_variants: product.has_variants,
          total_variants: product.total_variants || 0,
          is_new: product.is_new,
          is_exclusive: product.is_exclusive,
          category: product.category,
          subcategory: product.subcategory,
          // Stock fields — use what's available
          stock_quantity: product.stock_quantity || 0,
          total_stock: product.total_stock ||
            product.stock_quantity || 0,
          // Price fields — use what's available
          min_price: product.min_price ||
            product.price || 0,
          max_price: product.max_price ||
            product.price || 0,
          finalPrice: product.finalPrice ||
            product.price || 0,
        },
        ...filtered
      ].slice(0, MAX_ITEMS);

      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(updated)
      );
      return updated;
    });
  };

  const clearRecentlyViewed = () => {
    localStorage.removeItem(STORAGE_KEY);
    setRecentlyViewed([]);
  };

  return {
    recentlyViewed,
    addToRecentlyViewed,
    clearRecentlyViewed
  };
}
